import { render, staticRenderFns } from "./area-detail.vue?vue&type=template&id=113da405&"
import script from "./area-detail.vue?vue&type=script&lang=js&"
export * from "./area-detail.vue?vue&type=script&lang=js&"
import style0 from "./area-detail.vue?vue&type=style&index=0&id=113da405&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports